var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.53 24.47a.75.75 0 1 1-1.06 1.06L16 17.061 7.53 25.53a.75.75 0 0 1-1.06-1.06L14.94 16 6.47 7.53a.75.75 0 0 1 1.06-1.06L16 14.939l8.47-8.469a.75.75 0 0 1 1.06 1.06L17.061 16z"
  })));
};
export default SvgCross;